import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { UtilsService } from '../../../../services/utils.service'

interface OptionsFieldConfig {
    data: any[]
    placeholder: string
    key: string
    value: any
    selectedOption?: any
    type: 'SIMPLE' | 'LIVE-SEARCH'
}

@Component({
    selector: 'app-form-options-input',
    templateUrl: './form-options-input.component.html',
    styleUrls: ['./form-options-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormOptionsInputComponent),
            multi: true,
        },
    ],
})
export class FormOptionsInputComponent implements OnInit, ControlValueAccessor {
    @Input() label = ''
    @Input() id = ''
    @Input() control!: any
    @Input() isReadOnly = false
    @Input() isRequired = false

    @Input() fieldConfig!: Partial<OptionsFieldConfig>

    @Output() onSelectNewItem = new EventEmitter<any>()

    constructor(private readonly utils: UtilsService) {}

    public controlName = ''

    ngOnInit(): void {
        this.controlName = this.utils.stringToKebabCase(this.utils.getControlName(this.control) ?? '') + '-select-input'
    }

    value: any

    onChanged: (value: any) => void = () => {}

    onTouched: () => void = () => {}

    writeValue(value: string): void {
        this.value = value
    }

    registerOnChange(fn: any): void {
        this.onChanged = fn
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isReadOnly = isDisabled
    }

    onSelectedItem(selectedItem: any) {
        this.writeValue(selectedItem[this.fieldConfig.value])
        this.onChanged(selectedItem[this.fieldConfig.value])
        this.onSelectNewItem.emit(selectedItem)
    }
}
